module.exports = __webpack_public_path__ + "img/CL.88f69955.webp";